import { CATEGORIE_LOCATION } from '@/configuration/produitConf';
import addReferenceEcheancierToLigneCommande from '@/services/devisCommandes/echeanciers/addReferenceEcheancierToLigneCommande';

export function isLigneLocation(ligne, produitsDefault = null) {
  let produit = ligne.produit;
  if (produitsDefault && Array.isArray(produitsDefault)) {
    produit = produitsDefault.find(p => p.id === ligne.produitId);
  }
  return produit && produit.supportCommercial.categorieVente === CATEGORIE_LOCATION;
}
export function isLigneTlpe(ligne, societe) {
  return (societe && ligne.produitId === societe.produitIdDefautTlpe)
    || (ligne.produit && ligne.produit.produitDivers && ligne.produit.produitDivers.tlpe);
}
export function isLigneHonoraires(ligne, societe, strict = false) {
  if (strict) return societe && ligne.produitId === societe.produitIdHonoraire;
  return (societe && ligne.produitId === societe.produitIdHonoraire)
    || (ligne.produit && ligne.produit.produitDivers && ligne.produit.produitDivers.honoraire);
}
export function isLigneHonoraireFraisTraitement(ligne, societe) {
  return societe && ligne.produitId === societe.produitIdHonoraireFraisTraitement;
}
export function isLigneFraisTechnique(ligneCommande, societe) {
  return societe && ligneCommande.produitId === societe.produitIdDefautFraisTechnique;
}

export function gestionEcheanchier(devisCommande) {
  const echeanciersOld = devisCommande.echeanciers;
  devisCommande.echeanciers = [];
  devisCommande.lignesCommande.forEach(ligne => {
    addReferenceEcheancierToLigneCommande(ligne, devisCommande, echeanciersOld);
  });
}
